import { render, staticRenderFns } from "./ListForms.vue?vue&type=template&id=ac589f0a&scoped=true&"
import script from "./ListForms.vue?vue&type=script&lang=js&"
export * from "./ListForms.vue?vue&type=script&lang=js&"
import style0 from "./ListForms.vue?vue&type=style&index=0&id=ac589f0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac589f0a",
  null
  
)

export default component.exports